export * from './add-platform-frontend.descriptor';
export * from './panel-platform-frontend.descriptor';
